import PMBPagination from 'components/PMBPagination'
import React from 'react'
import { Button, Card, CardBody, Table } from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'

const TabPaymentDue = ({
  items = [],
  totalItems = 0,
  selectedRows = [],
  isLoading = false,
  batchData,
  currentPage = 0,
  rowsPerPage = 10,
  setCurrentPage,
  setRowsPerPage,
}) => {
  // Helper to group items by employeeName
  const groupItemsByEmployee = (itemList) => {
    const map = {}
    itemList.forEach((item) => {
      const key =
        item.employeeName ||
        (item.employeeUserId ? `User #${item.employeeUserId}` : item.nama || 'Karyawan')
      if (!map[key]) {
        map[key] = {
          name: key,
          amount: 0,
          status: item.status || 'Confirmed',
        }
      }
      map[key].amount += item.amount || item.total || 0
    })
    return Object.values(map)
  }

  const hasSelections = selectedRows && selectedRows.length > 0
  const processedItems = hasSelections ? selectedRows : items

  const processedGrouped = groupItemsByEmployee(processedItems)
  const totalProcessed = processedGrouped.reduce((acc, curr) => acc + curr.amount, 0)

  const periodTitle = batchData?.batchName
    ? `Weekly Batch ${batchData.batchName}`
    : 'Weekly 14 - 20 Jul 2026'

  const displayCount = totalItems || processedGrouped.length
  const paginatedGrouped =
    processedGrouped.length > rowsPerPage
      ? processedGrouped.slice(
          currentPage * rowsPerPage,
          (currentPage + 1) * rowsPerPage
        )
      : processedGrouped

  return (
    <div className="d-flex flex-column gap-4">
      {/* 1. Main Periode Due Section */}
      <div>
        <h6 className="fw-bold mb-3" style={{ color: '#101828', fontSize: '15px' }}>
          Periode Due: {periodTitle}
        </h6>
        <Card className="border-0 shadow-sm rounded-3 overflow-hidden">
          <CardBody className="p-0">
            <div className="table-responsive">
              <Table borderless className="mb-0 align-middle" style={{ fontSize: '14px' }}>
                <thead className="border-bottom text-muted" style={{ backgroundColor: '#F9FAFB' }}>
                  <tr>
                    <th className="py-3 px-4 fw-semibold" style={{ width: '40%' }}>
                      Nama Karyawan
                    </th>
                    <th className="py-3 px-4 fw-semibold" style={{ width: '40%' }}>
                      Jumlah Due
                    </th>
                    <th className="py-3 px-4 fw-semibold" style={{ width: '20%' }}>
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedGrouped.map((item, idx) => (
                    <tr key={idx} className="border-bottom">
                      <td className="py-3 px-4 fw-medium text-dark">{item.name}</td>
                      <td className="py-3 px-4 text-dark fw-bold">
                        Rp{newFormatThousandSeparator(item.amount, 0)}
                      </td>
                      <td className="py-3 px-4">
                        <span
                          className="px-3 py-1 rounded-pill d-inline-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: '#D1FADF',
                            color: '#027A48',
                            fontSize: '12px',
                            fontWeight: '600',
                          }}
                        >
                          Confirmed
                        </span>
                      </td>
                    </tr>
                  ))}
                  {processedGrouped.length === 0 && (
                    <tr>
                      <td colSpan="3" className="text-center py-4 text-muted fw-medium">
                        Tidak ada karyawan yang dipilih
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>

        {/* Pagination Component */}
        <div className="mt-3">
          <PMBPagination
            rowCount={displayCount}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            setCurrentPage={setCurrentPage}
            setRowsPerPage={setRowsPerPage}
          />
        </div>
      </div>
    </div>
  )
}

export default TabPaymentDue
